<template>
  <div>
    <v-dialog
      v-model="dialog"
      overlay-opacity
      persistent
      max-width="400"
    >
      <v-card class="pa-5">
        <v-row>
          <span>
            Click the copy button for the next step
          </span>
          <v-spacer></v-spacer>
          <v-btn @click="cp" icon text>
            <v-icon>
              mdi-content-copy
            </v-icon>
          </v-btn>
        </v-row>

      </v-card>

    </v-dialog>
  </div>
</template>


<script>
  import copy from "copy-to-clipboard"
  export default {
    props: {
      jwt: {
        type: String,
      }
    },
    data() {
      return {
        dialog: true,
      }
    },
    methods: {
      cp() {
        copy(this.jwt)
        this.$close(true)
      }
    },
  }
</script>